<template>
  <div ref="input" class="input" :class="{ full: input.full_width }">
    <label class="optionalPosition">
      {{ input.label }}
      <p class="optional" v-if="input.optional">(optional)</p>
    </label>
    <VuePhoneNumberInput
      v-model="answer"
      id="my-input"
      class="phoneInput"
      :no-country-selector="true"
      @input="limitNumbers"
    />
  </div>
</template>

<script type="text/javascript">
import VuePhoneNumberInput from "vue-phone-number-input";

export default {
  name: "PhoneInput",
  props: ["input", "questionIndex", "answerKey"],
  components: {
    VuePhoneNumberInput: VuePhoneNumberInput
  },
  data() {
    return {
      answer: null
    };
  },
  mounted() {},

  created() {
    this.answer = this.input.value;
  },
  firestore() {
    return {};
  },
  methods: {
    limitNumbers(e) {
      if (this.answer) {
        let num = this.answer.split(" ").join("");
        num = num.split("(").join("");
        num = num.split(")").join("");
        num = num.split("-").join("");
        if (num.length >= 11) {
          this.answer =
            "(" +
            num.substring(0, 3) +
            ") " +
            num.substring(3, 6) +
            "-" +
            num.substring(6, 10);
        }
      }
    }
  },
  watch: {
    answer() {
      this.$emit(
        "updateAnswer",
        this.questionIndex,
        this.answerKey,
        this.answer
      );
    }
  }
};
</script>

<style scoped lang="scss"></style>
